import { PERMISSIONS } from "@/services/permission"
import { FEATURE_SETS } from "@/services/featureSet"
import { requireSuppliers } from "@/router/routes/supplier"

export default [
  {
    path: "/machine/list",
    name: "MachineOverview",
    component: () => import("@/views/machine/MachineOverview"),
    meta: {
      title: "nav.machine.overview",
      requiresAuth: true,
      // Either right opens the page: it lists the catalogue's records and its packets, and shows
      // whichever of the two the reader may read (`services/catalogPackets.js`).
      requiresPermissions: [PERMISSIONS.VIEW_MACHINE_GENERAL, PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
  {
    path: "/machine/create",
    name: "MachineCreate",
    component: () => import("@/views/machine/MachineCreate"),
    meta: {
      title: "machine.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_MACHINE_GENERAL],
    },
  },
  // Two machines side by side, by their suppliers' prices (docs/suppliers.md, "Artikel vergleichen"): part of the
  // add-on SUPPLIER_INSIGHTS, on top of SUPPLIERS (`requireSuppliers`). Before the record route only for reading's
  // sake: a static segment outranks `:machineId` anyway.
  {
    path: "/machine/comparison",
    name: "MachineComparison",
    component: () => import("@/views/machine/MachineComparison.vue"),
    beforeEnter: requireSuppliers,
    meta: {
      title: "supplierInsights.item_comparison.title.MACHINE",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_MACHINE_GENERAL, PERMISSIONS.VIEW_MACHINE_PURCHASEPRICE],
      requiresFeatureSet: FEATURE_SETS.SUPPLIER_INSIGHTS,
    },
  },
  {
    path: "/machine/:machineId",
    name: "MachineDetail",
    props: true,
    component: () => import("@/views/machine/MachineDetail"),
    meta: {
      title: "nav.machine.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_MACHINE_GENERAL],
    },
  },
]
